import { useMemo } from 'react';

import { OrderMethodsListFilter } from 'pages/OrderMethods/OrderMethodsList';
import { useList, UseListValue } from 'react-admin';
import { cleanEmpty } from 'utils/cleanEmpty';

import { useOrderMethodsList } from './useOrderMethodsList';

type UseOrderMethodsContextResult = {
  context: UseListValue | UseListValue<never>;
  refetch: () => void;
};
export function useOrderMethodsContext(
  filters: OrderMethodsListFilter,
): UseOrderMethodsContextResult {
  const { orderMethods, refetch } = useOrderMethodsList(filters);
  const context = useList({
    data: orderMethods?.data?.methods.map((item, index) => ({ ...item, id: index })) ?? [],
    perPage: 10,
  });

  const emptyContext = useList({
    data: [],
    perPage: 10,
  });
  const resultContext = useMemo(
    () => (Object.keys(cleanEmpty(filters))?.length !== 0 ? context : emptyContext),
    [filters, context, emptyContext],
  );

  return { context: resultContext, refetch };
}
